import { useRoutePageContext } from "@components/ui/route-page-context"
import { navMenu } from "@lib/static-content"
import { Fragment } from "react"
export function NavMenu() {
  const { locale, currentPage } = useRoutePageContext()

  return (
    <ul className="list-none pt-0">
      {navMenu(locale).map((item) => (
        <Fragment key={item.label}>
          {item.page === "index" ? (
            <li
              className="m-[1rem] h-px bg-[var(--white-50)] opacity-50"
              aria-hidden="true"
            />
          ) : null}
          <li className={`${currentPage === item.page ? "active" : ""} text-[var(--white)]`.trim()}>
            <a
              className="group relative my-[15px] block h-[30px] w-full bg-[var(--deep-blue)] text-center text-[1.6rem] text-[var(--white)] leading-[30px] before:absolute before:top-1/2 before:left-0 before:h-[44px] before:w-full before:-translate-y-1/2 before:content-[''] lg:my-[10px]"
              aria-label={item.label}
              href={item.href}
              target={item.external ? "_blank" : undefined}
              rel={item.external ? "noreferrer" : undefined}
            >
              <i
                className={`${item.icon} ${currentPage === item.page ? "font-normal" : ""} group-hover:font-normal`}
              />
              <span className="pointer-events-none absolute top-0 left-[120%] hidden w-max opacity-0 transition-opacity duration-300 ease-linear group-hover:opacity-100 lg:block">
                {item.label}
              </span>
            </a>
          </li>
        </Fragment>
      ))}
    </ul>
  )
}

export default NavMenu
